import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Upload,
  FormInstance,
  UploadFile,
  UploadProps,
  Radio,
  RadioChangeEvent,
  Checkbox
} from "antd";
import FormItem from "antd/lib/form/FormItem";
import { FC, useCallback, useContext, useEffect, useState } from "react";
import { DeleteOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { AmountBreakdown, CreateDrawRequest, CreateDrawRequestPayment, DrawRequestResp } from "../../../../types/draw-request";
import { DataContext } from "../../../../contexts/DataContext";
import { turnDate, convertWithCommas } from "../../../../helpers";
import TextArea from "antd/lib/input/TextArea";
import { CheckboxProps } from "antd/es/checkbox";
import { ApproverResponse } from "../../../../types/approvers";
import RelatedLocation from "../../data/related-location";
import { AuthContext } from "../../../../contexts/AuthContext";

interface Props {
  form: FormInstance<CreateDrawRequestPayment>;
  form1: FormInstance<CreateDrawRequest>;
  drawRequestState: DrawRequestResp | undefined;
  setStep: React.Dispatch<React.SetStateAction<1 | 2 | 3>>;
  handleSecondForm: (isCreate: boolean, payload: any) => void;
  isEdit?: boolean;
  isCopy?: boolean;
  isLoading?: boolean;
  amounts: AmountBreakdown[];
  setAmounts: React.Dispatch<React.SetStateAction<AmountBreakdown[]>>;
  approvers: ApproverResponse[];
  reviewers: ApproverResponse[];
  setApprovers: React.Dispatch<React.SetStateAction<ApproverResponse[]>>;
  setReviewers: React.Dispatch<React.SetStateAction<ApproverResponse[]>>;
  handleCancel: () => void;
}

type NeedRequiredType = "invoiceCapitalCallDoc" | "sanctionDoc" | "agreementDoc" | "achWireInstructions" | "w9Form";

/**========================================================================
 *                          external const here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const SecondForm: FC<Props> = ({
  form,
  form1,
  setStep,
  handleSecondForm,
  isEdit,
  isCopy,
  isLoading,
  amounts,
  setAmounts,
  approvers,
  setApprovers,
  reviewers,
  setReviewers,
  handleCancel,
  drawRequestState
}) => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/

  /**========================================================================
   *                           form watches
   *========================================================================**/

  const sanctionNo = Form.useWatch("sanctionNo", form);
  const expatInChargeId = Form.useWatch("expatInChargeId", form);
  const expatOfficerId = Form.useWatch("expatOfficerId", form);
  const paymentMethodWatch: number = Form.useWatch("paymentMethod", form1) as number;
  const paymentMethod = form1.getFieldValue("paymentMethod") as any;

  /*============================ END OF SECTION ============================*/

  const {
    projects,
    codes,
    loading,
    drawRequestContext: {
      drawRequestData: { approvers: approversData, expatOfficers, paymentMethods },
      isDrawRequestDataFetching,
      isDrawRequestDataLoading
    }
  } = useContext(DataContext);
  const { userExtraInfo } = useContext(AuthContext);
  const [wasFormSubmitted, setWasFormSubmitted] = useState(false);
  const [textInfoColor, setTextInfoColor] = useState<"#a8a8a8f7" | "#ff4d4f">("#a8a8a8f7");

  const [invoiceFileList, setInvoiceFileList] = useState<UploadFile[]>([]);
  const [agreementFileList, setAgreementFileList] = useState<UploadFile[]>([]);
  const [sanctionFileList, setSanctionFileList] = useState<UploadFile[]>([]);
  const [achWireInstructionsFileList, setAchWireInstructionsFileList] = useState<UploadFile[]>([]);
  const [w9FormFileList, setW9FormFileList] = useState<UploadFile[]>([]);
  const [specifyPlaceHolder, setSpecifyPlaceHolder] = useState<string>("Specify nature of project");

  const [newPayee, setNewPayee] = useState<boolean>(false);
  const [GASanction, setGASanction] = useState<boolean>(false);

  useEffect(() => {
    if (newPayee)
      form.setFieldsValue({
        vendorCode: undefined
      });
  }, [form, newPayee]);

  useEffect(() => {
    /**============================================
     *               set lAst Values
     *=============================================**/
    // new payee
    setNewPayee(!!form.getFieldValue("isNewPayee") || false);
    // isGASanction
    setGASanction(!!form.getFieldValue("isGASanction") || false);
    //sanctionDoc
    if (form.getFieldValue("sanctionDoc")) setSanctionFileList([form.getFieldValue("sanctionDoc")]);
    //agreementDoc
    if (form.getFieldValue("agreementFile")) setAgreementFileList([form.getFieldValue("agreementFile")]);
    //achWireInstructionsDoc
    if (form.getFieldValue("achWireInstructions")) setAchWireInstructionsFileList([form.getFieldValue("achWireInstructions")]);
    //W9FormDoc
    if (form.getFieldValue("w9Form")) setW9FormFileList([form.getFieldValue("w9Form")]);
    //invoice files
    setInvoiceFileList([...(form.getFieldValue("invoiceFile") || [])]);
    /*=============== END OF SECTION ==============*/
  }, []);

  // useEffect(() => {
  //   if (!newPayee) {
  //     setW9FormFileList([]);
  //     form.setFieldsValue({ w9Form: undefined });
  //     setAchWireInstructionsFileList([]);
  //     form.setFieldsValue({ achWireInstructions: undefined });
  //   }
  // }, [newPayee]);

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Const here
   *========================================================================**/

  const propsW9FormDoc: UploadProps = {
    onRemove: (file: UploadFile<any>) => {
      setW9FormFileList([]);
      form.setFieldsValue({ w9Form: undefined });
    },
    beforeUpload: (file) => {
      setW9FormFileList([file]);
      form.setFieldsValue({ w9Form: file });
      return false;
    },
    fileList: w9FormFileList,
    accept: ".pdf",
    multiple: false,
    maxCount: 1
  };
  const propsAchWireInstructionsDoc: UploadProps = {
    onRemove: (file: UploadFile<any>) => {
      setAchWireInstructionsFileList([]);
      form.setFieldsValue({ achWireInstructions: undefined });
    },
    beforeUpload: (file) => {
      setAchWireInstructionsFileList([file]);
      form.setFieldsValue({ achWireInstructions: file });
      return false;
    },
    fileList: achWireInstructionsFileList,
    accept: ".pdf",
    multiple: false,
    maxCount: 1
  };

  const propsSanctionDoc: UploadProps = {
    onRemove: (file: UploadFile<any>) => {
      setSanctionFileList([]);
      form.setFieldsValue({ sanctionDoc: undefined });
    },
    beforeUpload: (file) => {
      setSanctionFileList([file]);
      form.setFieldsValue({ sanctionDoc: file });

      return false;
    },
    fileList: sanctionFileList,
    accept: ".pdf",
    multiple: false,
    maxCount: 1
  };
  const propsInvoiceFile: UploadProps = {
    onRemove: (file: UploadFile<any>) => {
      const files: UploadFile<any>[] = form.getFieldValue("invoiceFile") || [];

      form.setFieldsValue({
        invoiceFile: [...files.filter((v) => v.uid !== file.uid)]
      });
      setInvoiceFileList([...(form.getFieldValue("invoiceFile") || [])]);
    },
    beforeUpload: (file) => {
      form.setFieldsValue({
        invoiceFile: [...(form.getFieldValue("invoiceFile") || []), file]
      });

      setInvoiceFileList([...(form.getFieldValue("invoiceFile") || [])]);
      return false;
    },
    fileList: invoiceFileList,
    accept: ".csv, .pdf, .word, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel text/plain",
    multiple: true,
    maxCount: 30
  };

  // const propsAgreementFile: UploadProps = {
  //   onRemove: (file: any) => {
  //     setAgreementFileList([]);
  //     form.setFieldsValue({ agreementFile: undefined });
  //   },
  //   beforeUpload: (file) => {
  //     setAgreementFileList([file]);
  //     form.setFieldsValue({ agreementFile: file });
  //     return false;
  //   },
  //   fileList: agreementFileList,
  //   accept: ".csv, .pdf, .word, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel text/plain",
  //   multiple: false,
  //   maxCount: 1
  // };
  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/

  const onNewPayeeChange: CheckboxProps["onChange"] = (e) => {
    const isNewPayee = e.target.checked;
    form.setFieldsValue({
      isNewPayee
    });
    setNewPayee(isNewPayee);
  };
  const onGASanctionChange: CheckboxProps["onChange"] = (e) => {
    const value = e.target.checked;
    form.setFieldsValue({
      sanctionDoc: undefined,
      isGASanction: value
    });
    setSanctionFileList([]);
    setGASanction(value);
  };

  //todo: handle 2nd form
  const handleSecondForm2 = async (isCreate: boolean) => {
    const paymentForm = getFinalFormValues();
    // const drawRequest = {
    //   paymentMethod: form1.getFieldValue("paymentMethod"),
    //   initiator: form1.getFieldValue("initiator"),
    //   projectID: form1.getFieldValue("projectID"),
    //   accountID: form1.getFieldValue("accountID"),
    //   drawNumber: form1.getFieldValue("drawNumber"),
    //   amount: form1.getFieldValue("amount"),
    //   dueDate: form1.getFieldValue("dueDate"),
    //   MainCmsGlCodeID: form1.getFieldValue("MainCmsGlCodeID")
    //   // JvDepositGlCodeID: form1.getFieldValue("JvDepositGlCodeID"),
    //   // JvWithdrawalGlCodeID: form1.getFieldValue("JvWithdrawalGlCodeID")
    // };
    const invoiceCapitalCallDoc = paymentForm.invoiceFile || [];
    const agreementDoc = paymentForm.agreementFile;
    const sanctionDoc = paymentForm.sanctionDoc;
    const w9Form = paymentForm.w9Form;
    const achWireInstructions = paymentForm.achWireInstructions;
    delete paymentForm.invoiceFile;
    delete paymentForm.agreementFile;

    const payload = {
      paymentForm: paymentForm,
      // approversAux:
      // drawRequest: drawRequest,
      invoiceCapitalCallDoc: [...invoiceCapitalCallDoc],
      agreementDoc,
      sanctionDoc,
      w9Form,
      achWireInstructions
    };

    handleSecondForm(isCreate, payload);
  };

  const addNewApprover = () => {
    const id = Math.floor(Math.random() * 999999) * approvers.length;
    setApprovers((old) => [...old, { id, email: "", hasApproved: null, role: "approver", sortOrder: old.length + 1, userID: undefined }]);
  };
  const addNewReviewer = () => {
    const id = Math.floor(Math.random() * 999999) * approvers.length;
    setReviewers((old) => [...old, { id, email: "", hasApproved: null, role: "reviewer", sortOrder: old.length + 1, userID: undefined }]);
  };

  const getFinalFormValues = () => {
    return { ...fixForm2(), approvers: fixApprovers(), amountBreakdowns: fixAmounts() };
  };

  const fixForm2 = () => {
    const values: any = { ...form.getFieldsValue() };
    const form2Values: any = {};

    for (const field in values) {
      if (field in values) {
        const key = field as keyof CreateDrawRequestPayment;
        if (!key.includes("approver") && !key.includes("labelAmount") && !key.includes("valueAmount") && !key.includes("glCodeAmount")) {
          form2Values[key] = values[key];
        }
      }
    }
    return form2Values;
  };

  const fixAmounts = () => {
    const amountsArray: { name: string; amount: number; glCodeID: number; relatedLocation: string; salesTax: number }[] = [];
    const values = { ...form.getFieldsValue() };

    for (let i = 0; i < amounts.length; i++) {
      const id = amounts[i].id;
      const am = {
        name: values[`labelAmount${id}`] || "",
        amount: values[`valueAmount${id}`] || 0,
        salesTax: values[`salesTax${id}`] || 0,
        relatedLocation: values[`relatedLocation${id}`] || "",
        glCodeID: values[`glCodeAmount${id}`]
      };
      if (am) amountsArray.push(am);
    }
    return amountsArray;
  };
  const fixApprovers = () => {
    const approversArray: number[] = [];
    const values = { ...form.getFieldsValue() };

    for (let i = 0; i < approvers.length; i++) {
      const id = approvers[i].id;
      const ap = values[`approver${id}`];
      if (ap) approversArray.push(ap);
    }
    return approversArray;
  };

  const doFinalSteps = () => {
    setWasFormSubmitted(() => true);
    setAmountTotal(true);
  };

  const addNewAmount = () => {
    const id = Math.floor(Math.random() * 999999) * amounts.length;
    setAmounts((old) => [...old, { id, name: "", amount: 0, salesTax: 0, relatedLocation: "" }]);
  };
  const deleteAmount = (id: number) => {
    setAmounts((old) => [...old.filter((am) => am.id !== id)]);
  };
  const deleteApprover = (id: number) => {
    setApprovers((old) => [...old.filter((ap) => ap.id !== id)]);
  };
  const deleteReviewer = (id: number) => {
    setReviewers((old) => [...old.filter((ap) => ap.id !== id)]);
  };

  const setAmountTotal = (submitted?: true): void => {
    let sum: number = 0;
    for (let i = 0; i < amounts.length; i++) {
      const amount: number = form.getFieldValue(`valueAmount${amounts[i].id}`) || 0;

      sum += Math.round(amount * 100);
    }
    sum = sum / 100;
    form.setFieldsValue({ amountTotal: sum });
    const amount = form1.getFieldValue("amount") || 0;
    if ((wasFormSubmitted || submitted) && sum !== amount) setTextInfoColor("#ff4d4f");
    else {
      setTextInfoColor("#a8a8a8f7");
    }
  };

  const goBack = () => {
    setWasFormSubmitted(false);
    setTextInfoColor("#a8a8a8f7");
    setStep(1);
  };

  const onChargeToChange = (e: RadioChangeEvent) => {
    const value = e.target.value;

    switch (value) {
      case "capitalExpenditure":
        setSpecifyPlaceHolder("Specify nature of project");
        break;
      case "tenantRelated":
        setSpecifyPlaceHolder("Specify tenant and type of cost");
        break;

      default:
        setSpecifyPlaceHolder("Specify expense type");
        break;
    }
  };

  const isAchCheck = () => {
    return [3, 4, 5].includes(paymentMethod);
  };

  const onApproverChanged = (value: number, id: number) => {
    setApprovers((old) => [...old.map((app) => (app.id === id ? { ...app, userID: value } : app))]);
  };
  const onReviewerChanged = (value: number, id: number) => {
    setReviewers((old) => [...old.map((app) => (app.id === id ? { ...app, userID: value } : app))]);
  };

  const needRequired = (value: NeedRequiredType) => {
    const preC = !isEdit || isCopy;
    const con = !drawRequestState || (!!drawRequestState && !drawRequestState[value]);

    return preC || con;
  };

  const includesWire = useCallback(() => {
    return ["1", "2"].includes(`${paymentMethod}`) || ["1", "2"].includes(`${paymentMethodWatch}`);
  }, [paymentMethodWatch, paymentMethod]);

  /*============================ END OF SECTION ============================*/

  return (
    <>
      {/* /========================================================================  HTML here
    ========================================================================*/}

      <>
        <Row>
          <Col>
            <h2>Step 2: Payment Application</h2>
          </Col>
        </Row>
        <hr style={{ marginBottom: "8px" }} />
        <div className="form-container-centered">
          <Row style={{ width: "80%" }}>
            <Col span={24}>
              <Form
                scrollToFirstError={true}
                name="draw-request-form"
                labelCol={{ span: 12 }}
                labelAlign="left"
                form={form}
                initialValues={{ chargeTo: "capitalExpenditure" }}
                onFinish={() => handleSecondForm2(true)}
              >
                {/* FROM PREVIOUS FORM */}
                <Row style={{ marginBottom: "8px" }}>
                  <Col span={9}>
                    <label style={{ fontWeight: "bold" }}>Payment Method:</label>
                  </Col>
                  <Col>
                    <label>{paymentMethods.find((pa) => pa.id === paymentMethod)?.name}</label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: "8px" }}>
                  <Col span={9}>
                    <label style={{ fontWeight: "bold" }}>Payment For:</label>
                  </Col>
                  <Col>
                    <label>{projects.find((pa) => pa.id === form1.getFieldValue("projectID"))?.name}</label>
                  </Col>
                </Row>

                <Row>
                  <Col span={24}>
                    <Row style={{ display: "flex" }}>
                      <FormItem
                        style={{ flex: 1 }}
                        labelCol={{ span: 10 }}
                        labelAlign="left"
                        label="Sanction No."
                        name="sanctionNo"
                        rules={[{ required: true, message: "sanction number is required" }]}
                      >
                        <Input style={{ width: "100%" }} inputMode="text" />
                      </FormItem>
                      <FormItem style={{ width: 158, paddingLeft: 5 }} labelAlign="left" name="isGASanction">
                        <Checkbox onChange={onGASanctionChange}>Use G&A Sanction</Checkbox>
                      </FormItem>
                    </Row>
                  </Col>
                </Row>

                <FormItem
                  labelCol={{ span: 9 }}
                  labelAlign="left"
                  label="Sanction File"
                  name="sanctionDoc"
                  rules={[
                    {
                      required: needRequired("sanctionDoc") && sanctionNo?.toLowerCase() !== "hrga-03" && !GASanction,
                      message: "sanction file is required"
                    }
                  ]}
                >
                  <>
                    {!!form.getFieldValue("sanctionDoc") ? "" : ""}
                    <Upload disabled={GASanction} {...propsSanctionDoc}>
                      <Row>
                        <Col>
                          {" "}
                          <Button disabled={GASanction} icon={<UploadOutlined />}>
                            Select File
                          </Button>
                        </Col>
                        <Col style={{ marginLeft: "15px", display: "flex", alignItems: "center" }}>
                          <p className="small-gray"> Please do not upload G&A BOD</p>
                        </Col>
                      </Row>
                      {!needRequired("sanctionDoc") && !!drawRequestState && !sanctionFileList.length && (
                        <Row>
                          <Col span={24}>
                            <Row>
                              <UploadOutlined style={{ marginRight: 5 }} />
                              <p style={{ fontSize: 12 }}> {drawRequestState.sanctionDoc}</p>
                            </Row>
                          </Col>
                        </Row>
                      )}
                    </Upload>
                  </>
                </FormItem>

                <Row style={{ marginBottom: "8px" }}>
                  <Col span={9}>
                    <label style={{ fontWeight: "bold" }}>Payment due date:</label>
                  </Col>
                  <Col>
                    <label> {turnDate(form1.getFieldValue("dueDate"))}</label>
                  </Col>
                </Row>
                {/* NEW Fields */}

                {/* NEW Fields */}
                <Row style={{ marginBottom: "8px" }}>
                  <Col span={9}>
                    <label style={{ fontWeight: "bold" }}>Draw No. / Invoice No. :</label>
                  </Col>
                  <Col>
                    <label> {form1.getFieldValue("drawNumber")}</label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: "8px" }}>
                  <Col span={9}>
                    <label style={{ fontWeight: "bold" }}>Payment amount:</label>
                  </Col>
                  <Col>
                    <label> ${convertWithCommas(form1.getFieldValue("amount"))}</label>
                  </Col>
                </Row>
                {/* FROM PREVIOUS FORM */}

                {/* AMOUNT BREAK DOWN */}
                <Row style={{ marginBottom: "10px" }}>
                  {includesWire() && <Col span={9}> </Col>}
                  <Col span={includesWire() ? 15 : 24}>
                    <Row>
                      <Col span={6}>
                        <label> Amount Break down:</label>
                      </Col>
                      <Col span={5} style={{ display: "flex", flexDirection: "column" }}>
                        <label> Amount:</label>
                        <p
                          style={{
                            fontSize: "10px",
                            color: textInfoColor,
                            margin: "0px",
                            display: "flex",

                            alignItems: "center"
                          }}
                        >
                          (*the total needs to be ${convertWithCommas(form1.getFieldValue("amount"))})
                        </p>
                      </Col>
                      <Col span={3} style={{ display: "flex" }}>
                        <label>Sales Tax:</label>
                      </Col>
                      <Col span={2} style={{ display: "flex" }}>
                        <label> Related Location:</label>
                      </Col>
                      <Col span={8} style={{ display: "flex", justifyContent: "space-between" }}>
                        <label> {isAchCheck() ? " GL Code:" : ""}</label>
                        <Button onClick={() => addNewAmount()} type="primary" shape="circle" icon={<PlusOutlined />} size="small" />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <FormItem
                  style={{ display: "none" }}
                  initialValue={0}
                  name="amountTotal"
                  rules={[
                    () => ({
                      validator(_, value: number) {
                        const amount = form1.getFieldValue("amount");
                        if (value !== amount) {
                          return Promise.reject(new Error("amount break down is not correct"));
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}
                >
                  <Input style={{ display: "none" }}></Input>
                </FormItem>
                <Row className="no-margin" style={{ marginBottom: "8px" }}>
                  {includesWire() && <Col span={9}> </Col>}
                  <Col span={includesWire() ? 15 : 24}>
                    {amounts.map((am, index) => (
                      <Row key={am.id}>
                        <Col span={6}>
                          <FormItem
                            style={{ width: "98%", marginRight: "10px" }}
                            label={index + 1}
                            name={`labelAmount${am.id}`}
                            rules={[{ required: true, message: "description amount is required" }]}
                          >
                            <Input style={{ width: "100%" }} inputMode="text" />
                          </FormItem>
                        </Col>
                        <Col span={5}>
                          <FormItem
                            style={{ width: "98%", marginRight: "10px" }}
                            initialValue={0}
                            label=""
                            name={`valueAmount${am.id}`}
                            rules={[{ required: true, message: "amount is required" }]}
                          >
                            <InputNumber
                              onChange={() => {
                                setAmountTotal();
                              }}
                              addonBefore="$"
                              style={{ width: "100%", marginRight: "15px" }}
                              inputMode="decimal"
                            />
                          </FormItem>
                        </Col>
                        <Col span={3}>
                          <FormItem
                            initialValue={0}
                            style={{ width: "98%", marginRight: "10px" }}
                            label=""
                            name={`salesTax${am.id}`}
                            rules={[{ required: true, message: "sales tax is required" }]}
                          >
                            <InputNumber addonBefore="$" style={{ width: "100%", marginRight: "15px" }} inputMode="decimal" />
                          </FormItem>
                        </Col>
                        <Col span={2}>
                          <Row>
                            <Col span={23}>
                              <FormItem
                                style={{ width: "98%", marginRight: "10px" }}
                                labelCol={{ span: 9 }}
                                labelAlign="left"
                                name={`relatedLocation${am.id}`}
                                rules={[{ required: true, message: "related location is required" }]}
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  showSearch={true}
                                  options={RelatedLocation}
                                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                                />
                              </FormItem>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={8}>
                          <Row>
                            <Col span={amounts.length > 1 ? 20 : 24}>
                              {isAchCheck() && (
                                <FormItem
                                  style={{ width: "100%", marginRight: "10px" }}
                                  labelCol={{ span: 9 }}
                                  labelAlign="left"
                                  name={`glCodeAmount${am.id}`}
                                  rules={[{ required: true, message: "gl code is required" }]}
                                >
                                  <Select
                                    style={{ width: "100%" }}
                                    showSearch={true}
                                    options={codes.map((item) => ({ label: `${item.gl_code} (${item.account_name})`, value: item.id }))}
                                    loading={loading}
                                    onChange={(value) => form.setFieldsValue({ [`glCodeAmount${am.id}`]: value })}
                                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                                  />
                                </FormItem>
                              )}
                            </Col>
                            {amounts.length > 1 && (
                              <Col span={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                <Button
                                  danger
                                  onClick={() => {
                                    deleteAmount(am.id);
                                    setAmountTotal();
                                  }}
                                  type="primary"
                                  shape="circle"
                                  icon={<DeleteOutlined />}
                                  size="small"
                                />
                              </Col>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    ))}
                    {/* AMOUNT BREAK DOWN */}
                  </Col>
                </Row>
                <Row>
                  <Col span={9}>
                    <label className="required-start">Payee name:</label>
                  </Col>
                  <Col span={15}>
                    <Row>
                      <Col span={6}>
                        <FormItem name="isNewPayee">
                          <Checkbox checked={newPayee} onChange={onNewPayeeChange}>
                            New
                          </Checkbox>
                        </FormItem>
                      </Col>
                      <Col span={18}>
                        <FormItem name="payee" rules={[{ required: true, message: "payee name is required" }]}>
                          <Input style={{ width: "100%" }} />
                        </FormItem>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {newPayee && (
                  <>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label="ACH/Wire instructions"
                      name="achWireInstructions"
                      rules={[{ required: needRequired("achWireInstructions"), message: "ACH/Wire instructions file is required" }]}
                    >
                      <>
                        {!!form.getFieldValue("achWireInstructions") ? "" : ""}
                        <Upload {...propsAchWireInstructionsDoc}>
                          <Row>
                            <Col>
                              {" "}
                              <Button icon={<UploadOutlined />}>Select File</Button>
                            </Col>
                            <Col style={{ marginLeft: "15px", display: "flex", alignItems: "center" }}></Col>
                          </Row>
                          {!needRequired("achWireInstructions") && !!drawRequestState && !achWireInstructionsFileList.length && (
                            <Row>
                              <Col span={24}>
                                <Row>
                                  <UploadOutlined style={{ marginRight: 5 }} />
                                  <p style={{ fontSize: 12 }}> {drawRequestState.achWireInstructions}</p>
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </Upload>
                      </>
                    </FormItem>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label="W-9 Form"
                      name="w9Form"
                      rules={[{ required: needRequired("w9Form"), message: "W-9 Form file is required" }]}
                    >
                      <>
                        {!!form.getFieldValue("w9Form") ? "" : ""}
                        <Upload {...propsW9FormDoc}>
                          <Row>
                            <Col>
                              {" "}
                              <Button icon={<UploadOutlined />}>Select File</Button>
                            </Col>
                            <Col style={{ marginLeft: "15px", display: "flex", alignItems: "center" }}></Col>
                          </Row>
                          {!needRequired("w9Form") && !!drawRequestState && !w9FormFileList.length && (
                            <Row>
                              <Col span={24}>
                                <Row>
                                  <UploadOutlined style={{ marginRight: 5 }} />
                                  <p style={{ fontSize: 12 }}> {drawRequestState.w9Form}</p>
                                </Row>
                              </Col>
                            </Row>
                          )}
                        </Upload>
                      </>
                    </FormItem>
                  </>
                )}

                <FormItem
                  labelCol={{ span: 9 }}
                  labelAlign="left"
                  label="Vendor Code"
                  name="vendorCode"
                  // rules={[{ required: true }]}
                >
                  <Input placeholder=" If it is new payee, leave it blank. " disabled={newPayee} style={{ width: "100%" }} />
                </FormItem>
                {`${paymentMethod}` === "4" && (
                  <FormItem
                    labelCol={{ span: 9 }}
                    labelAlign="left"
                    label="Check Special Instructions"
                    name="checkSpecialInstructions"
                    // rules={[{ required: true }]}
                  >
                    <TextArea style={{ width: "100%", height: "100%", minHeight: 100 }} inputMode="text" />
                  </FormItem>
                )}
                {/* <FormItem
                  labelCol={{ span: 9 }}
                  labelAlign="left"
                  label="Related Location"
                  name="relatedLocation"
                  // rules={[{ required: true }]}
                >
                  <Select
                    style={{ width: "100%" }}
                    showSearch={true}
                    options={RelatedLocation}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </FormItem> */}
                <FormItem
                  labelCol={{ span: 9 }}
                  labelAlign="left"
                  style={{ margin: "0px" }}
                  label="Address"
                  name="address"
                  // rules={[{ required: true }]}
                >
                  <Input style={{ width: "100%" }} inputMode="text" />
                </FormItem>

                <Row>
                  <Col span={9}></Col>
                  <Col span={15}>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label=""
                      name="address2"
                      // rules={[{ required: false }]}
                    >
                      <Input style={{ width: "100%" }} inputMode="text" />
                    </FormItem>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "13px" }}>
                  <Col span={9}>
                    <label className="required-start">Charge to:</label>
                  </Col>
                  <Col span={15}>
                    <Row>
                      <Col span={12} style={{ paddingTop: "16px" }}>
                        <FormItem style={{ margin: "0px" }} name="chargeTo" rules={[{ required: true, message: "charge to is required" }]}>
                          <Radio.Group
                            onChange={onChargeToChange}
                            style={{ display: "flex", flexDirection: "column" }}
                            value="capitalExpenditure"
                          >
                            <Radio
                              style={{
                                marginTop: "10px"
                              }}
                              value="capitalExpenditure"
                            >
                              Capital Expenditure
                            </Radio>
                            <Radio
                              style={{
                                marginTop: "10px"
                              }}
                              value="tenantRelated"
                            >
                              Tenant Related
                            </Radio>
                            <Radio
                              style={{
                                marginTop: "10px"
                              }}
                              value="generalAdministrative"
                            >
                              General & Administrative
                            </Radio>
                            <Radio
                              style={{
                                marginTop: "10px"
                              }}
                              value="taxFinancial"
                            >
                              Tax & Financial
                            </Radio>
                          </Radio.Group>
                        </FormItem>
                      </Col>
                      <Col span={12} style={{ paddingTop: "16px" }}>
                        <FormItem
                          className="all-div-height-100"
                          style={{ margin: "0px", height: "100%" }}
                          name="specify"
                          rules={[{ required: true, message: "please specify" }]}
                        >
                          <TextArea placeholder={specifyPlaceHolder} style={{ width: "100%", height: "100%" }} inputMode="text" />
                        </FormItem>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {`${paymentMethod}` !== "4" && (
                  <>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label="Bank Name"
                      name="bankName"
                      rules={[
                        {
                          required: true,
                          message: `bank name is required`
                        }
                      ]}
                    >
                      <Input inputMode="text" />
                    </FormItem>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label={`${paymentMethod === 2 ? "SWIFT" : "Bank ABA"}`}
                      name="abbaOrSwiftAccountNo"
                      rules={[
                        {
                          required: true,
                          message: `${paymentMethod === 2 ? "SWIFT " : "bank ABA "}` + "is required"
                        }
                      ]}
                    >
                      <Input inputMode="text" />
                    </FormItem>

                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label="Account No."
                      name="accountNo"
                      rules={[{ required: true, message: "account number is required" }]}
                    >
                      <Input style={{ width: "100%" }} />
                    </FormItem>
                  </>
                )}
                {paymentMethod === 5 && (
                  <>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label="Debit Block ID"
                      name="debitBlockID"
                      rules={[
                        {
                          required: true,
                          message: `debit block id is required`
                        }
                      ]}
                    >
                      <Input inputMode="text" />
                    </FormItem>
                  </>
                )}

                <FormItem
                  labelCol={{ span: 9 }}
                  labelAlign="left"
                  label="Invoice/Capital Call"
                  name="invoiceFile"
                  rules={[{ required: needRequired("invoiceCapitalCallDoc"), message: "Invoice/Capital Call file is required" }]}
                >
                  <>
                    {!!form.getFieldValue("invoiceFile") ? "" : ""}
                    <Row>
                      <Upload {...propsInvoiceFile}>
                        <Button icon={<UploadOutlined />}>Select File</Button>
                      </Upload>
                    </Row>
                    {!needRequired("invoiceCapitalCallDoc") && !!drawRequestState && !invoiceFileList.length && (
                      <>
                        {(drawRequestState.invoiceCapitalCallDoc || []).map((item) => (
                          <Row style={{ marginBottom: 5 }}>
                            <Col span={24}>
                              <Row>
                                <UploadOutlined style={{ marginRight: 5 }} />
                                <p style={{ fontSize: 12 }}> {item}</p>
                              </Row>
                            </Col>
                          </Row>
                        ))}
                      </>
                    )}
                  </>
                </FormItem>

                {form1.getFieldValue("amount") >= 10000 && (
                  // <FormItem
                  //   labelCol={{ span: 9 }}
                  //   labelAlign="left"
                  //   label="Agreement path"
                  //   name="agreementFile"
                  //   rules={[{ required: needRequired("agreementDoc"), message: "agreement document is required" }]}
                  // >
                  //   <>
                  //     {!!form.getFieldValue("agreementFile") ? "" : ""}
                  //     <Row>
                  //       <Upload {...propsAgreementFile}>
                  //         <Button icon={<UploadOutlined />}>Select File</Button>
                  //       </Upload>
                  //     </Row>
                  //     {!needRequired("agreementDoc") && !!drawRequestState && !agreementFileList.length && (
                  //       <Row>
                  //         <Col span={24}>
                  //           <Row>
                  //             <UploadOutlined style={{ marginRight: 5 }} />
                  //             <p style={{ fontSize: 12 }}> {drawRequestState.agreementDoc}</p>
                  //           </Row>
                  //         </Col>
                  //       </Row>
                  //     )}
                  //   </>
                  // </FormItem>

                  <>
                    <Row>
                      <Col span={9}></Col>
                      <Col span={15}>
                        If applicable, please indicate the folder path of contract related to the payment. (Over $10,000) (Approvers should
                        confirm that the requested payment is in accordance with the terms stipulated in the contract.)
                      </Col>
                    </Row>
                    <FormItem
                      labelCol={{ span: 9 }}
                      labelAlign="left"
                      label="Agreement path"
                      name="agreementPath"
                      rules={[{ required: needRequired("agreementDoc"), message: "agreement path is required" }]}
                    >
                      <Input style={{ width: "100%" }} />
                    </FormItem>
                  </>
                )}

                <Row style={{ marginBottom: "8px" }}>
                  <Col span={9}>
                    <label style={{ fontWeight: "bold" }}>Initiator:</label>
                  </Col>
                  <Col>
                    <label>{form1.getFieldValue("initiator")}</label>
                  </Col>
                </Row>
                {/* ============================== Approvers ============================== */}

                <Row style={{ marginBottom: "20px" }}>
                  <Col span={9}>
                    <label>Approvers:</label>
                  </Col>
                  <Col span={15} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button onClick={() => addNewApprover()} type="primary" shape="circle" icon={<PlusOutlined />} size="small" />
                  </Col>
                </Row>
                {approvers.map((ap, index) => (
                  <div key={ap.id}>
                    <Row>
                      <Col span={9}>
                        <label className="required-start">{`${index + 1} Approver ${index + 1}:`}</label>
                      </Col>
                      <Col span={approvers.length > 1 ? 13 : 15}>
                        <FormItem
                          className="no-margin"
                          style={{ marginBottom: "2px" }}
                          name={`approver${ap.id}`}
                          rules={[{ required: true, message: `approver ${index + 1} is required` }]}
                        >
                          <Select
                            onChange={(value: any) => {
                              onApproverChanged(value, ap.id);
                            }}
                            style={{ width: "100%" }}
                            showSearch={true}
                            loading={isDrawRequestDataFetching || isDrawRequestDataLoading}
                            options={approversData.map((apMap) => ({
                              label: `${apMap.firstName} ${apMap.lastName} (${apMap.email})`,
                              value: apMap.id,
                              disabled:
                                !!approvers.find((approver) => approver.userID === apMap.id) ||
                                expatInChargeId === apMap.id ||
                                expatOfficerId === apMap.id ||
                                apMap.id === userExtraInfo?.id
                            }))}
                            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                            disabled={ap.hasApproved !== null && !isCopy}
                          />
                        </FormItem>
                      </Col>
                      {approvers.length > 1 && ap.hasApproved === null && (
                        <Col span={2} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                          <Button
                            danger
                            onClick={() => {
                              deleteApprover(ap.id);
                            }}
                            type="primary"
                            shape="circle"
                            icon={<DeleteOutlined />}
                            size="small"
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                ))}
                {/* ============================== Approvers ============================== */}

                {/* ============================== reviewers ============================== */}
                {/* <>
                  <Row style={{ marginBottom: "20px", marginTop: "20px" }}>
                    <Col span={9}>
                      <label>Reviewers:</label>
                    </Col>
                    <Col span={15} style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button onClick={() => addNewReviewer()} type="primary" shape="circle" icon={<PlusOutlined />} size="small" />
                    </Col>
                  </Row>
                  {reviewers.map((re, index) => (
                    <div key={re.id}>
                      <Row>
                        <Col span={9}>
                          <label className="required-start">{`${index + 1} Reviewer ${index + 1}:`}</label>
                        </Col>
                        <Col span={reviewers.length > 1 ? 13 : 15}>
                          <FormItem
                            className="no-margin"
                            style={{ marginBottom: "2px" }}
                            name={`reviewer${re.id}`}
                            rules={[{ required: true, message: `reviewer ${index + 1} is required` }]}
                          >
                            <Select
                              onChange={(value: any) => {
                                onReviewerChanged(value, re.id);
                              }}
                              style={{ width: "100%" }}
                              showSearch={true}
                              loading={isDrawRequestDataFetching || isDrawRequestDataLoading}
                              options={approversData.map((apMap) => ({
                                label: `${apMap.firstName} ${apMap.lastName} (${apMap.email})`,
                                value: apMap.id,
                                disabled:
                                  !!reviewers.find((approver) => approver.userID === apMap.id) ||
                                  expatInChargeId === apMap.id ||
                                  expatOfficerId === apMap.id ||
                                  apMap.id === userExtraInfo?.id
                              }))}
                              filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                              disabled={re.hasApproved !== null && !isCopy}
                            />
                          </FormItem>
                        </Col>
                        {reviewers.length > 1 && re.hasApproved === null && (
                          <Col span={2} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <Button
                              danger
                              onClick={() => {
                                deleteReviewer(re.id);
                              }}
                              type="primary"
                              shape="circle"
                              icon={<DeleteOutlined />}
                              size="small"
                            />
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                </> */}
                {/* ============================== reviewers ============================== */}

                {form1.getFieldValue("amount") >= 10000 && (
                  <FormItem
                    className="no-margin"
                    style={{ marginBottom: "2px" }}
                    labelCol={{ span: 9 }}
                    labelAlign="left"
                    label={`${approvers.length + 1} Expat in Charge`}
                    name="expatInChargeId"
                    rules={[{ required: true, message: "expat in charge is required" }]}
                  >
                    <Select
                      // placeholder="required for 10K payment"
                      style={{ width: "100%" }}
                      showSearch={true}
                      loading={isDrawRequestDataFetching || isDrawRequestDataLoading}
                      options={expatOfficers.map((ap) => ({
                        label: `${ap.firstName} ${ap.lastName} (${ap.email})`,
                        value: ap.id,
                        disabled:
                          !!approvers.find((approver) => approver.userID === ap.id) ||
                          expatInChargeId === ap.id ||
                          expatOfficerId === ap.id ||
                          ap.id === userExtraInfo?.id
                      }))}
                      filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    />
                  </FormItem>
                )}
                {form1.getFieldValue("amount") >= 10000 && (
                  <FormItem
                    className="no-margin"
                    labelCol={{ span: 9 }}
                    labelAlign="left"
                    label={`${approvers.length + 2} Expat Officer`}
                    name="expatOfficerId"
                    rules={[{ required: true, message: "expat officer is required" }]}
                  >
                    <Select
                      //   placeholder="required for 10K payment"
                      style={{ width: "100%" }}
                      showSearch={true}
                      loading={isDrawRequestDataFetching || isDrawRequestDataLoading}
                      options={expatOfficers.map((ap) => ({
                        label: `${ap.firstName} ${ap.lastName} (${ap.email})`,
                        value: ap.id,
                        disabled:
                          !!approvers.find((approver) => approver.userID === ap.id) ||
                          expatInChargeId === ap.id ||
                          expatOfficerId === ap.id ||
                          ap.id === userExtraInfo?.id
                      }))}
                      filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    />
                  </FormItem>
                )}

                <Row style={{ marginTop: "33px" }}>
                  <Col style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <Button key="cancel" onClick={() => handleCancel()} danger type="primary">
                      Close
                    </Button>

                    <Button
                      key="back"
                      onClick={() => {
                        goBack();
                      }}
                    >
                      Back
                    </Button>

                    <div>
                      {(!isEdit || drawRequestState?.isDraft || isCopy) && (
                        <Button
                          key="submitForLater"
                          type="primary"
                          style={{ marginRight: 8 }}
                          onClick={() => {
                            handleSecondForm2(false);
                          }}
                        >
                          Save for Later
                        </Button>
                      )}
                      <Button
                        key="submit"
                        htmlType="submit"
                        type="primary"
                        onClick={() => {
                          doFinalSteps();
                        }}
                      >
                        Next
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </>

      {/*============================ END OF SECTION ============================*/}
    </>
  );
};
